import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=a8557b56&"
import script from "./loginView.vue?vue&type=script&lang=js&"
export * from "./loginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports